import httpService from "./httpService";

export default {
  findAllByDocCodeAndToDeptId(docCode, docId) {
    return httpService.get("/vbIncomingDoc/findAllByDocCodeAndToDeptId", {
      params: {docCode: docCode, docId: docId}
    });
  },

  findByForwardIncomingProcessId(forwardProcessId) {
    let params = {forwardProcessId: forwardProcessId};
    return httpService.get("/vbIncomingDoc/findByForwardIncomingProcessId", {
      params: params
    });
  },

  // findByForwardIncomingDocId(forwardIncomingDocId, id) {
  //   let params = {forwardIncomingDocId: forwardIncomingDocId};
  //   return httpService.get(
  //     `/vbIncomingDoc/findByForwardIncomingDocId/${id}`,
  //     {params: params}
  //   );
  // }
};



// WEBPACK FOOTER //
// ./src/services/vbIncomingDocService.js